import { c as _c } from "react/compiler-runtime";
interface SeoStructureDataProps {
  seoStructuredData: any;
}
export function SeoStructureData(t0) {
  const $ = _c(19);
  const {
    seoStructuredData
  } = t0;
  const organizationData = seoStructuredData?.organization;
  const websiteData = seoStructuredData?.website;
  const softwareApplicationData = seoStructuredData?.softwareApplication;
  const videosData = seoStructuredData?.videos;
  const itemsListData = seoStructuredData?.itemsList;
  const faqData = seoStructuredData?.faq;
  let t1;
  if ($[0] !== organizationData) {
    t1 = organizationData?.length > 1 && <script id="organization" type="application/ld+json" dangerouslySetInnerHTML={{
      __html: organizationData
    }} />;
    $[0] = organizationData;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] !== websiteData) {
    t2 = websiteData?.length > 1 && <script id="website" type="application/ld+json" dangerouslySetInnerHTML={{
      __html: websiteData
    }} />;
    $[2] = websiteData;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  let t3;
  if ($[4] !== softwareApplicationData) {
    t3 = softwareApplicationData?.length > 1 && <script id="application" type="application/ld+json" dangerouslySetInnerHTML={{
      __html: softwareApplicationData
    }} />;
    $[4] = softwareApplicationData;
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  let t4;
  if ($[6] !== faqData) {
    t4 = faqData?.length > 1 && <script id="faq" type="application/ld+json" dangerouslySetInnerHTML={{
      __html: faqData
    }} />;
    $[6] = faqData;
    $[7] = t4;
  } else {
    t4 = $[7];
  }
  let t5;
  if ($[8] !== videosData) {
    t5 = videosData?.length > 1 && <script id="videoData" type="application/ld+json" dangerouslySetInnerHTML={{
      __html: videosData
    }} />;
    $[8] = videosData;
    $[9] = t5;
  } else {
    t5 = $[9];
  }
  let t6;
  if ($[10] !== itemsListData) {
    t6 = itemsListData?.length > 1 && <script id="itemsList" type="application/ld+json" dangerouslySetInnerHTML={{
      __html: itemsListData
    }} />;
    $[10] = itemsListData;
    $[11] = t6;
  } else {
    t6 = $[11];
  }
  let t7;
  if ($[12] !== t1 || $[13] !== t2 || $[14] !== t3 || $[15] !== t4 || $[16] !== t5 || $[17] !== t6) {
    t7 = <span key="seoStructuredData">{t1}{t2}{t3}{t4}{t5}{t6}</span>;
    $[12] = t1;
    $[13] = t2;
    $[14] = t3;
    $[15] = t4;
    $[16] = t5;
    $[17] = t6;
    $[18] = t7;
  } else {
    t7 = $[18];
  }
  return t7;
}